<template>
  <div id="app">
    <NavBar></NavBar>
    <Banner></Banner>
    <router-view />
    <Footer></Footer>
    <FloatContact></FloatContact>
  </div>
</template>

<script>
import    NavBar from '@/components/NavBar.vue'
import Banner from '@/components/Banner.vue'
import Footer from '@/components/Footer.vue'
import FloatContact from '@/components/FloatContact.vue'
export default {
  name: "HomeView",
  components: {
    NavBar,
    Banner,
    Footer,
    FloatContact,
  },
  computed:{
    // bannerConfig(){
    //   const routeMap = {
    //     '/': { id: '1' },
    //     '/groupBusiness': { id: '2' },
    //     '/groupNews': { id: '4' },
    //     '/expertTeam': { id: '3' },
    //     '/aboutUs': { id: '5' },
    //     '/groupDetail': { id: '2' },
    //     '/newsDetail': { id: '4' },
    //   }
    //   return routeMap[this.$route.path] || {}
    // }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body,
#app {
  width: 100% !important;
  min-height: 100vh !important;
  height: auto !important;
}

img {
  max-width: 100%;
  display: block;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
